import { EntityIcon } from '@common/Entity/EntityIcons';
import { SnowflakePwdAuthBanner } from '@common/Fabric/SnowflakePwdAuthBanner';
import { ProjectHeader } from '@common/Header/PageHeader';
import { HUB_URL } from '@common/packageHub/constants';
import { PackageTabKeys } from '@common/project/constants';
import { Entity } from '@common/types/Entity';
import { Private_Routes } from '@common/url';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { Spinner, Centered, MetadataPageContainer } from '@prophecy/ui-v3';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { usePackageDetail, PackageDetail } from './PackageDetail';

function Package({ uid, version, tab }: { tab: string; uid: string; version?: string }) {
  const navigate = useNavigate();
  const {
    response: { data, isLoading },
    versionToFetch
  } = usePackageDetail(uid, version);
  if (isLoading) {
    return (
      <Centered>
        <Spinner />
      </Centered>
    );
  }
  if (!(data && uid)) return null;
  const snapshot = data.ProjectReleaseByProjectAndReleaseTag.projectSnapshot;
  const header = (
    <ProjectHeader
      crumbs={[
        {
          children: 'Package Hub',
          icon: <EntityIcon size='m' entity={Entity.Package} />,
          elementType: 'link',
          to: HUB_URL.PACKAGE,
          'data-test-id': 'package-entity-detail-package-hub-link'
        },
        {
          children: snapshot.name,
          elementType: 'link',
          to: Private_Routes.Package.home.getUrl({ uid }),
          'data-test-id': 'package-entity-detail-package-name-link'
        }
      ]}
    />
  );
  const main = (
    <PackageDetail
      insideDialog={false}
      uid={uid}
      version={versionToFetch}
      data={snapshot}
      tab={tab}
      onUsePackage={async (uid, language) => {
        navigate(
          Private_Routes.Create_Entity.project.getUrl(undefined, {
            language: language,
            dependencyId: uid
          })
        );
      }}
    />
  );
  return (
    <MetadataPageContainer banner={<SnowflakePwdAuthBanner />} header={header} main={main}></MetadataPageContainer>
  );
}
export default function Page() {
  const { uid, tab: _tab } = useParams<ExtractUrlPathVariables<typeof Private_Routes.Package.tab.url>>();
  const tab = Object.values(PackageTabKeys).find((item) => item === _tab) || PackageTabKeys.About;
  const [searchParams] = useSearchParams();
  const version = searchParams.get('version') as string | undefined;

  return <Package tab={tab} uid={uid as string} version={version} />;
}
